import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    titleLineOne: {
        id: '_.choose_amount.early_repayment.titleLineOne',
        defaultMessage: 'Interested in repaying early?'
    },
    titleLineTwo: {
        id: '_.choose_amount.early_repayment.titleLineTwo',
        defaultMessage: "Here's how it could look"
    },
    repay: {
        id: '_.choose_amount.early_repayment.repay',
        defaultMessage: `What if I repay early in full on:`
    },
    orIn: {
        id: '_.choose_amount.early_repayment.or_in',
        defaultMessage: 'Or in...'
    },
    fourWeeks: {
        id: '_.choose_amount.early_repayment.four_weeks',
        defaultMessage: '4 weeks'
    },
    sixMonths: {
        id: '_.choose_amount.early_repayment.six_months',
        defaultMessage: '6 months'
    },
    nineMonths: {
        id: '_.choose_amount.early_repayment.nine_months',
        defaultMessage: '9 months'
    },
    breakdownTitleYears: {
        id: '_.choose_amount.early_repayment.breakdown_title_years',
        defaultMessage:
            'If you repay in {years} year, {months} months and {days} days...'
    },
    breakdownTitleMonthsAndDays: {
        id: '_.choose_amount.early_repayment.breakdown_title_months_and_days',
        defaultMessage: 'If you repay in {months} months and {days} days...'
    },
    breakdownTitleMonths: {
        id: '_.choose_amount.early_repayment.breakdown_title_months',
        defaultMessage:
            'If you repay in {months, plural, one {# month} other {# months}}...'
    },
    breakdownTitleDays: {
        id: '_.choose_amount.early_repayment.breakdown_title_days',
        defaultMessage:
            'If you repay in {days, plural, one {# day} other {# days}}...'
    },
    seeExampleSchedule: {
        id: '_.choose_amount.early_repayment.example_repayment_schedule',
        defaultMessage: 'See example repayment schedule'
    },
    info: {
        id: '_.choose_amount.early_repayment.info',
        defaultMessage:
            'Your repayment schedule will always be for {months} months but you can repay early in your dashboard at any time.'
    }
});
